import { useEffect, useRef } from 'react'

/**
 * This hook can be used to run a callback when a function component will umount preventing the callback "looping"
 * when some dependency changes.
 *
 * @param callback The callback to execute when component will umount
 *
 * @param dependencies [Optional] The callback's depednencies
 *
 * For more reference:
 * https://medium.com/geekculture/run-code-on-component-unmount-with-the-custom-hook-useonunmount-5355bd99e11e
 */
const useOnUnmount = (callback: React.EffectCallback, dependencies?: React.DependencyList) => {
  const isUnmounting = useRef(false)

  useEffect(
    () => () => {
      isUnmounting.current = true
    },
    []
  )

  useEffect(
    () => () => {
      if (isUnmounting.current) {
        callback()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies
  )
}

export default useOnUnmount
